import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import './CompanyAutoComplete.css';
import ProvisionListOrderNumber from '../components/ProvisionListOrderNumber'; 
import { connect } from 'react-redux';
import * as ProvisioningActions from '../actions/Provisioning';
import * as CompanyActions from '../actions/Companies';
import { filterByNumber, filterPagination, getNumbers } from '../actions/Numbers';
import { getTrunkGroupList } from '../actions/Inteliquent';
import { toast } from 'react-toastify';
import * as BoxesActions from '../actions/EpikBoxes';


class SearchNewNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectAll: false,
      selectedNumbers: [],
      provisionModalOpen: false,
      companies: [],
      error: null,
      gateways: [],
      sameForAll: false,
      provider:
      process.env.REACT_APP_TEMP_NUMBER_CAREER_INTELIQUENT == 'true' ? 'Inteliquent' : 'VoiceTel',
    };

    this.token = localStorage.getItem('jwtToken') || null;
  }

  async componentWillMount() {
    if (
      this.props.user.role === 'superAdmin' ||
      this.props.user.role === 'companyGroupAdmin' ||
      this.props.user.role === 'supportEngineer'
    ) {
      this.props.getCompanies(this.token, undefined, 'yes');
      this.props.getGateways(this.token);
    }
  }

  companySearchFilter = async ({ suggestion }) => {
    const { getNumberCompanyEmails } = this.props;
    this.setState({
      selectedNumber: '',
    });
    if (suggestion !== null) {
      this.setState({ selectedCompany: suggestion._id });
      getNumberCompanyEmails(
        this.token,
        suggestion._id,
        true,
        undefined,
        undefined,
        suggestion.name,
      );
    }
  };

  onToggleChange = () => {
    this.setState({ sameForAll: !this.state.sameForAll });
  };

  onOrder = async e => {
    const {  orderNumber, clearSearchedNumbers, resetSelectedNumbers } = this.props;
    const { sameForAll, selectedNumbers } = this.state;

    if (!e.cid || e.tn === '' || e.route === '') {
      toast.error('All fields are required');
      return;
    }

    let routeInfo;
    try {
      routeInfo = JSON.parse(e.route);
    } catch (error) {
      routeInfo = e.route;
    }

    const createOrderData = (tn) => ({
      cid: e.cid,
      route: routeInfo?.route || routeInfo,
      gateway: routeInfo?.gateway || routeInfo,
      sms: e.sms,
      tn: tn,
      uid: e.uid || '',
      tempDID: e.tempDID,
    });

    const createBody = (tnItem) => ({
      tnOrder: {
        tnList: {
          tnItem: tnItem,
        },
      },
    });

    const token = this.token;

    const orderNumberAndUpdateState = async (data) => {
      const body = createBody(data);
   
      const res = await orderNumber(token, { data: body, cid: e?.cid });
      if (res) {
        this.setState({ orderedNumbers: data });
        clearSearchedNumbers();
        resetSelectedNumbers([]);
        this.toggleProvisionModal();
        this.props.getAssignedNumbers(
          token,
          this.props.boxDetails?.assignedTo?._id,
          this.props.boxDetails?.epikBoxUser?._id,
          false,
        );
      }
    };

    if (sameForAll) {
      const dataPromises = selectedNumbers.map(async tn => createOrderData(tn.telephoneNumber));
      const dataList = await Promise.all(dataPromises);
      await orderNumberAndUpdateState(dataList);
    } else {
      const data = createOrderData(e.tn);
      await orderNumberAndUpdateState([data]);
    }
  };

  handleSelectAll = () => {
    const { selectAll } = this.state;
    const { tnResultData } = this.props;
    const newSelectAll = !selectAll;
    const selectedNumbers = newSelectAll ? tnResultData.map(item => item) : [];

    this.setState({
      selectAll: newSelectAll,
      selectedNumbers
    });
  };
  handleCheckboxChange = (number) => {
    const { selectedNumbers } = this.state;

    // Check if the full number object is already selected
    const newSelectedNumbers = selectedNumbers.some(selected => selected.telephoneNumber === number.telephoneNumber)
      ? selectedNumbers.filter(selected => selected.telephoneNumber !== number.telephoneNumber)
      : [...selectedNumbers, number];  // Add the full object
    this.setState({
      selectedNumbers: newSelectedNumbers,
      selectAll: newSelectedNumbers.length === this.props.tnResultData.length
    });
  };

  toggleProvisionModal = () => {
    this.setState(prevState => ({
      provisionModalOpen: !prevState.provisionModalOpen
    }));
  };

  handleProvision = () => {
    this.setState({
      selectAll: false,
    });
    this.props.onCancel()
    this.toggleProvisionModal();
  };

  render() {
    const { isOpen, onCancel, tnResultData, companies, gateways, filterEmails } = this.props;
    const { selectAll, selectedNumbers, provisionModalOpen, error } = this.state;

    if (error) {
      return <div>{error}</div>;
    }

    return (
      <React.Fragment>
        <Modal isOpen={isOpen}>
          <ModalHeader className="custom-modal-header">DID Search</ModalHeader>
          <ModalBody>
            <table>
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={this.handleSelectAll}
                    />
                  </th>
                  <th>Number</th>
                </tr>
              </thead>
              <tbody>
                {tnResultData.map((number, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedNumbers.some(selected => selected.telephoneNumber === number.telephoneNumber)}
                        onChange={() => this.handleCheckboxChange(number)}
                      />
                    </td>
                    <td>{number.telephoneNumber}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {selectedNumbers.length > 0 && (
              <ModalFooter>
                <Button outline color="secondary" onClick={() => {
                  onCancel()
                  this.setState({
                    selectAll: false,
                  });
                }}>
                  Cancel
                </Button>
                <Button color="primary" onClick={this.handleProvision}>
                  Provision Selected
                </Button>
              </ModalFooter>
            )}
          </ModalBody>
        </Modal>
        <Modal isOpen={provisionModalOpen} toggle={this.toggleProvisionModal} style={{ maxWidth: '1200px', width: '1200px' }}>
          <ModalHeader className="custom-modal-header">
            DID Provision
          </ModalHeader>
          <ModalBody>
            <ProvisionListOrderNumber
              companies={companies}
              selectedNumbers={selectedNumbers}
              filterEmails={filterEmails}
              gateways={gateways}
              companySearchFilter={this.companySearchFilter}
              onOrder={this.onOrder}
              onToggleChange={this.onToggleChange}
              sameForAll={this.state.sameForAll}
              provider={this.state.provider}
            />
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  selectedNumbers: state.UIState.provisioning.selectedNumbers,
  searchedNumbers: state.AppState.provisioning.searchedNumbers,
  gateways: state.AppState.provisioning.gateways,
  user: state.AppState.user,
  companies: state.AppState.companies,
  filterEmails: state.UIState.provisioning.filterEmails,
  numbers: state.AppState.numbers,
  boxDetails: state.AppState.boxDetails.box,
});

const mapDispatchToProps = dispatch => ({
  orderNumber: (token, number) =>
    dispatch(ProvisioningActions.orderNumber(token, number)),
  getNumberCompanyEmails: (token, id, uid, type, gflag, name) =>
    dispatch(ProvisioningActions.getNumberCompanyEmails(token, id, uid, type, gflag, name)),
  filterPagination: pagination => dispatch(filterPagination(pagination)),
  getCompanies: (token, pagination, disablePaginate) =>
    dispatch(CompanyActions.getCompanies(token, pagination, disablePaginate)),
  filterByNumber: (token, id, number, pagination) =>
    dispatch(filterByNumber(token, id, number, pagination)),
  getTrunkGroupList: token => dispatch(getTrunkGroupList(token)),
  resetSelectedNumbers: number => dispatch(ProvisioningActions.resetSelectedNumbers(number)),
  clearSearchedNumbers: () => dispatch(ProvisioningActions.clearSearchedNumbers()),
  getGateways: token => dispatch(ProvisioningActions.getGateways(token)),
  getAssignedNumbers: (token, cid, uid, priStatus) =>
    dispatch(BoxesActions.getAssignedNumbers(token, cid, uid, priStatus)),
});


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchNewNumber);
